import {AbstractControl, ValidatorFn} from '@angular/forms';

export function isObjectValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const isObject = typeof control.value === 'object';
        return isObject ?  null : {isObjectName: {value: control.value}};
    };
}
